exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-js-switch[data-v-bda021f2]{margin:2px;font-size:16px!important}.icon[data-v-bda021f2]{vertical-align:middle}.has-tooltip[data-v-bda021f2]{cursor:help}.disabled[data-v-bda021f2]{color:#bcc3c9}", ""]);

// exports
